import { CommonLabel } from "@brg/ui";
import { useBookEditor } from "_deziiign/books/pages/BookEdit/providers/bookEditorProvider";
import { bTag } from "core";
import { BTag } from "core/components/bTag/bTag";
import { BTagsGridNew } from "core/components/bTag/bTagsGridNew/bTagsGridNew";
import { ColumnLabelGroup, Footnote } from "shared/pages/projectEdit/styles";

import { useTranslation } from "react-i18next";
import { useMemo } from "react";

const BookTagsField = () => {
    const { bookAndChaptersTags } = useBookEditor();
    const { t } = useTranslation();
    const hasTags = useMemo(() => bookAndChaptersTags.length > 0, [bookAndChaptersTags]);
    return (
        <ColumnLabelGroup>
            <CommonLabel label={t('project_edit.tags')} infoText={t('project_edit.book_tags_info')}/>
            {hasTags && (
                <BTagsGridNew scrollMode="all" style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                    {bookAndChaptersTags.map((value: any) => (
                        <BTag
                            tag={value}
                            educational={value.isEducationTag}
                            organization={value.isTeamTag}
                            isProjectsTag
                            key={value.tagId}
                        >
                            {bTag.title(value)}
                        </BTag>
                    ))}
                </BTagsGridNew>
            )}
            {!hasTags && (
                <Footnote>
                    {t('project_edit.no_book_tags')}
                </Footnote>
            )}
        </ColumnLabelGroup>
    )
}

export default BookTagsField;import { CommonLabel } from "@brg/ui";
import { useBookEditor } from "_deziiign/books/pages/BookEdit/providers/bookEditorProvider";
import { bTag } from "core";
import { BTag } from "core/components/bTag/bTag";
import { BTagsGridNew } from "core/components/bTag/bTagsGridNew/bTagsGridNew";
import { ColumnLabelGroup, Footnote } from "shared/pages/projectEdit/styles";

import { useTranslation } from "react-i18next";
import { useMemo } from "react";

const BookTagsField = () => {
    const { bookAndChaptersTags } = useBookEditor();
    const { t } = useTranslation();
    const hasTags = useMemo(() => bookAndChaptersTags.length > 0, [bookAndChaptersTags]);
    return (
        <ColumnLabelGroup>
            <CommonLabel label={t('project_edit.tags')} infoText={t('project_edit.book_tags_info')}/>
            {hasTags && (
                <BTagsGridNew scrollMode="all" style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                    {bookAndChaptersTags.map((value: any) => (
                        <BTag
                            tag={value}
                            educational={value.isEducationTag}
                            organization={value.isTeamTag}
                            isProjectsTag
                            key={value.tagId}
                        >
                            {bTag.title(value)}
                        </BTag>
                    ))}
                </BTagsGridNew>
            )}
            {!hasTags && (
                <Footnote>
                    {t('project_edit.no_book_tags')}
                </Footnote>
            )}
        </ColumnLabelGroup>
    )
}

export default BookTagsField;